<div class="page search">
  <header class="page-h">
    <h1 class="page-h__title">{{ title }}</h1>
  </header>

  @if (mode === 'tag') {
    <p class="search__tagged">Tagged <span class="tag-chip">{{ query }}</span></p>
  }

  <div class="search__toolbar">
    <!-- Phones get a "Show" select instead of the tab rail (as on the profile), so every type stays reachable. -->
    <ut-view-picker class="search__picker" [options]="tabs" [value]="tab" (selected)="selectTab($event)"></ut-view-picker>
    <nav class="tabs search__tabs" aria-label="Result type">
      @for (t of tabs; track t.value) {
        <a class="tab" [class.is-active]="t.value === tab" [attr.aria-current]="t.value === tab ? 'page' : null"
           [uiSref]="stateName" [uiParams]="{ contentType: t.value }">{{ t.label }}</a>
      }
    </nav>
    @if (query) {
      <!-- Disabled rather than removed on Users (people have no date), so the toolbar keeps its layout. -->
      <label class="search__sort">
        <span class="search__sort-label">Sort by</span>
        <select class="select" [disabled]="!sortable" (change)="setSort($any($event.target).value)">
          <option value="newest" [selected]="sort === 'newest'">Newest first</option>
          <option value="oldest" [selected]="sort === 'oldest'">Oldest first</option>
        </select>
      </label>
    }
  </div>

  <p class="sr-only" role="status">{{ status }}</p>

  @if (!query) {
    <div class="card empty">
      <span class="empty__icon" aria-hidden="true"><span class="material-icons">search</span></span>
      <p class="empty__title">Enter a search</p>
      <p class="empty__text">Use the search in the header to find articles, tools, projects, people and forum topics.</p>
    </div>
  } @else {
    @if (total !== null && results.length) {
      <p class="search__count">{{ total | number }} {{ total === 1 ? 'result' : 'results' }}</p>
    }

    @if (results.length) {
      <h2 class="sr-only">Results</h2>
      <div class="search__list" [attr.aria-busy]="store.isLoading">
        @for (item of results; track resultId(item)) {
          @if (item.type === 'user') {
            <ut-search-person-card [id]="resultId(item)" [person]="item" [user]="user" [highlight]="query"></ut-search-person-card>
          } @else {
            <ut-community-feed-item [id]="resultId(item)" [item]="item" [user]="user || {}" [highlight]="query"></ut-community-feed-item>
          }
        }
      </div>
    } @else if (store.isLoading) {
      <ut-skeleton-list [announce]="false"></ut-skeleton-list>
    } @else if (!store.failed) {
      <div class="card empty">
        <span class="empty__icon" aria-hidden="true"><span class="material-icons">search</span></span>
        <p class="empty__title">{{ emptyTitle }}</p>
      </div>
    }

    @if (store.failed && !store.isLoading) {
      <div class="alert alert--error" role="alert">
        <span class="material-icons" aria-hidden="true">error_outline</span>
        <p class="alert__text"><b>Search results couldn't load.</b> Check your connection and try again.</p>
        <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="retry()">Retry</button>
      </div>
    }

    @if (results.length && !store.isLastPage && !store.failed) {
      <button type="button" class="ut-btn ut-btn--secondary more" [disabled]="store.isLoading" (click)="loadMore()">View more</button>
    }
  }
</div>
